if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.form.addEventListener("submit", this.onSubmitHandler);
        this.cartNotification = document.querySelector("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
        this.makeBundle = this.querySelector(".js-make-bundle");

        if (this.makeBundle) {
          this.makeBundle.addEventListener("click", (e) =>
            this.onSubmitHandler(e, this.makeBundle.dataset.id)
          );
        }

        //  this.submitButton.addEventListener('click', event => {
        //       fetch('/?view=cart')
        //       .then(response => response.text())
        //       .then(cartData => {
        //           document.querySelector('#main-cart-items .js-contents').innerHTML = cartData;
        //       });
        //       fetch('/?view=cart-total')
        //       .then(response => response.text())
        //       .then(cartTotal => {
        //           document.querySelector('#main-cart-footer .js-contents').innerHTML = cartTotal;
        //       });
        //   });
      }

      async onSubmitHandler(evt, bundleWithId) {
        evt?.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        console.log("BODY: ", config.body);

        if (bundleWithId) {
          await fetch(routes.cart_add_url + ".js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: [
                {
                  id: bundleWithId,
                  quantity: 1,
                },
              ],
            }),
          });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cartNotification.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // this.cartNotification.renderContents(response);
            }
          })
          .then(() => {
            this.fetchCartItemCount();
          })
          .then(() => {
            fetch("/?view=cart")
              .then((response) => response.text())
              .then((cartData) => {
                document.querySelector(
                  "#main-cart-items .js-contents"
                ).innerHTML = cartData;
              })
              .then(() => {
                const refreshEvent = new Event("custom:reattachSample");
                window.dispatchEvent(refreshEvent);
              })
              .then(() => {
                this.includeAccordionsInit();
              });
            fetch("/?view=cart-total")
              .then((response) => response.text())
              .then((cartTotal) => {
                document.querySelector(
                  "#main-cart-footer .js-contents"
                ).innerHTML = cartTotal;
              });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });

        fetch("/?view=cart")
          .then((response) => response.text())
          .then((cartData) => {
            document.querySelector("#main-cart-items .js-contents").innerHTML =
              cartData;
          });
        fetch("/?view=cart-total")
          .then((response) => response.text())
          .then((cartTotal) => {
            document.querySelector("#main-cart-footer .js-contents").innerHTML =
              cartTotal;
          })
          .finally(
            window.dispatchEvent(new CustomEvent("custom:open-cart-drawer"))
          );
      }

      async fetchCartItemCount() {
        const res = await fetch("/cart.js");
        const data = await res.json();
        const itemCounters = document.querySelectorAll(".cart-items-number");
        const giftWrapperCheckbox = document.querySelector("#gift-wrapping");
        itemCounters.forEach((counter) => {
          counter.innerHTML = data.item_count;
        });
        const cartDraverCheckoutBtn = document.querySelector(
          ".cart__checkout-button"
        );
        if (data.item_count > 0) {
          cartDraverCheckoutBtn.classList.remove("disabled");
        } else {
          cartDraverCheckoutBtn.classList.add("disabled");
        }
      }

      includeAccordionsInit() {
        let cartAccordionsContainers = document.querySelectorAll(
          ".cart-drawer .accordion_container"
        );
        cartAccordionsContainers.forEach((accordionContainer) => {
          const accordionBtn =
            accordionContainer.querySelector(".accordion_button");
          const accordionContent = accordionContainer.querySelector(
            ".accordion__content"
          );
          accordionContent.style.height = accordionContent.scrollHeight + "px";

          accordionBtn.addEventListener("click", function () {
            this.classList.toggle("active");

            const content = this.nextElementSibling;
            if (accordionContent.classList.contains("open")) {
              accordionContent.classList.remove("open");
              accordionContent.classList.add("closed");
            } else {
              accordionContent.classList.remove("closed");
              accordionContent.classList.add("open");
              accordionContent.style.height =
                accordionContent.scrollHeight + "px";
            }
          });
        });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
